<div class="columns is-marginless has-background-primary has-text-white">
    <div class='column is-size-4 has-text-weight-semibold'>
        {#if $opponent}Lineups: {$opponent}, {gameDateDisplay} { :else } No game set {/if}
    </div>
    <div class='column is-narrow'>
        <GameDetailsEditor opponent='{$opponent}' gameDate='{$gameDate}' />
    </div>
</div>



<script>
    import { format } from 'date-fns';
    import GameDetailsEditor from './GameDetailsEditor.html';

    export default {
        data() {
            return {
            };
        },
        computed : {
            gameDateDisplay: function( state ) {
                return state.$gameDate ? format(new Date(state.$gameDate), 'LLL d @ haa') : '';
            }
        },
        components: {
            GameDetailsEditor
        }
    }
</script>
